import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import MenuItem from "@material-ui/core/MenuItem";
import Toolbar from "@material-ui/core/Toolbar";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import AccountCircle from "@material-ui/icons/AccountCircle";

import ImportExport from "@material-ui/icons/ImportExport";

import { Link } from "@reach/router";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
}));

export default function ButtonAppBar(props) {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Toolbar style={{ justifyContent: "space-between" }}>
          <div style={{ display: "flex" }}>
            <Link
              to={"/dashboard"}
              style={{ textDecoration: "none", color: "white" }}
            >
              <MenuItem>
                <IconButton
                  aria-label="account of current user"
                  aria-controls="primary-search-account-menu"
                  aria-haspopup="true"
                  color="inherit"
                >
                  <ImportExport />
                </IconButton>
                <p>Exportar</p>
              </MenuItem>
            </Link>

            {props.user &&
              (props.user.rol === "admin" ||
                props.user.rol === "superadmin") && (
                <Link
                  to={"/accounts"}
                  style={{ textDecoration: "none", color: "white" }}
                >
                  <MenuItem>
                    <IconButton
                      aria-label="account of current user"
                      aria-controls="primary-search-account-menu"
                      aria-haspopup="true"
                      color="inherit"
                    >
                      <AccountCircle />
                    </IconButton>
                    <p>Cuentas</p>
                  </MenuItem>
                </Link>
              )}
          </div>

          <Button color="inherit" onClick={props.logout}>
            Salir
          </Button>
        </Toolbar>
      </AppBar>
    </div>
  );
}
